<template>
<div>
  <Breadcrumb :home="home" :datas="navDatas" @onNav="handNav" />
  <Item v-if="isRoleAll" :isEndLine="true" :data="{name: '全选'}" :checked="checkAll" @onClick="toggleAll" />
  <ListPage :style="{ height: isRoleAll ? (!isAccount ? `${scale === 1 ? height : height/(scale-0.07)}px` : `${scale === 1 ? 254 : 254/scale}px`) : `${scale === 1 ? 314 : 314/scale}px` }" v-loading="loading">
  <template v-if="isAccount">
    <Item
    isArrow
    :isDown="false"
    :isCheckbox="false"
    :ids="resultIds"
    v-for="item in treeRole"
    :key="item.id"
    :data="item"
    :count="count"
    @onClick="handleRole" />
  </template>
  <template v-else>
    <Item
    isArrow
    :ids="resultIds"
    v-for="item in treeRole"
    :key="item.id"
    :data="item"
    :count="count"
    @onClick="handleItem"
    @onDown="handleRole"
    :isHeadimg="isHeadimg" />
  </template>
  <Item
    :ids="resultIds"
    v-for="item in treeAccount"
    :key="item.id"
    :data="item"
    @onClick="handleItem2"
    :isHeadimg="isHeadimg" />
  </ListPage>
</div>
</template>

<script>
import api from './api'
import Breadcrumb from './breadcrumb'
import Item from './item'
import ListPage from './listPage'
import _ from 'lodash'
import { getAllIds, isAll } from './tree'
import mixScale from './mixins/scale'

export default {
  inject: ['multiple'],
  mixins: [mixScale],
  components: {
    Breadcrumb,
    Item,
    ListPage
  },
  props: {
    home: Object,
    isHeadimg: {
      type: Boolean,
      default: false
    },
    selectList: {
      type: Array,
      default: () => []
    },
    count: {
      type: Object,
      default: () => {}
    },
    isAccount: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number,
      default: 254
    }
  },
  data() {
    return {
      resultIds: [],
      treeRole: [],
      treeAccount: [],
      navDatas: [],
      currentRoleId: '',
      currentRoleSubjectId: '',
      checkAll: false,
      loading: false
    }
  },
  computed: {
    isRoleAll() {
      if (this.multiple) {
        if (!this.isAccount) {
          return true
        }
        if (this.treeAccount.length) {
          return true
        }
      }
      return false
    }
  },
  watch: {
    selectList(list) {
      this.resultIds = getAllIds(list)
      // checkAll
      this.setCheckAll(this.resultIds)
    },
    async currentRoleId(id) {
      await this.getTreeRole(this.currentRoleSubjectId)
      if (this.isAccount) {
        await this.getAccountByRoleId(id)
      }

      // checkAll
      this.setCheckAll(this.resultIds)

      this.setCount(id)
    }
  },
  mounted() {
    // init role
    this.getTreeRole('')
  },
  methods: {
    async getRole(subjectId) {
      try {
        this.loading = true
        const { data } = await api.apiRoleList({
          parentPermissionSubjectId: subjectId
        })
        this.loading = false
        return data
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    async getAccountByRoleId(roleId) {
      if (!roleId) {
        this.treeAccount = []
        return true
      }

      try {
        this.loading = true
        const { data } = await api.apiAcountListRoleId({}, null, {
          hasRole: true,
          roleIdList: roleId
        })
        this.loading = false
        this.treeAccount = data
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    async getTreeRole(id) {
      const data = await this.getRole(id)
      this.treeRole = data
    },
    handNav(item, level) {
      if (level) {
        const {
          id,
          permissionSubjectId
        } = item
        this.navDatas = this.navDatas.slice(0, level)
        this.currentRoleId = id
        this.currentRoleSubjectId = permissionSubjectId
      } else {
        this.navDatas = []
        this.currentRoleId = ''
        this.currentRoleSubjectId = ''
      }
    },
    handleRole(item) {
      const {
        id,
        permissionSubjectId
      } = item
      this.navDatas.push(item)
      this.currentRoleId = id
      this.currentRoleSubjectId = permissionSubjectId
    },
    handleItem(item) {
      this.$emit('onToggle', item)
      // if (this.multiple) {
      //   this.resultIds = toggle(this.resultIds, item)
      // } else {
      //   this.resultIds = [item.id]
      // }
    },
    handleItem2(item) {
      this.$emit('onToggle', item)
      // if (this.multiple) {
      //   this.resultIds = toggleCount(this.resultIds, item.id, this.count, this.currentRoleId)
      // } else {
      //   this.resultIds = [item.id]
      // }
    },
    toggleAll() {
      this.checkAll = !this.checkAll

      const allItems = this.isAccount ? this.treeAccount : [
        ...this.treeRole,
        ...this.treeAccount
      ]

      // let allIds = getAllIds(allItems)

      if (this.checkAll) {
        this.count[this.currentRoleId] = allItems.length
      } else {
        this.count[this.currentRoleId] = 0
      }
      this.$emit('onAll', allItems, this.checkAll)
    },
    setCheckAll(ids) {
      const allItems = this.isAccount ? this.treeAccount : [
        ...this.treeRole,
        ...this.treeAccount
      ]

      let allIds = getAllIds(allItems)

      this.checkAll = isAll(ids, allIds)
    },
    setCount(id) {
      const allItems = this.isAccount ? this.treeAccount : [
        ...this.treeRole,
        ...this.treeAccount
      ]

      let allIds = []
      allItems.map(item => {
        allIds.push(item.id)
      })

      const isIds = _.intersection(this.resultIds, allIds)

      if (isIds.length) {
        this.count[id] = isIds.length
      }
    }
  }
}
</script>
